export default function About() {
  return (
    <>
      <h2>About Page balle balle</h2>
    </>
  );
}
